import { Button } from "antd";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import OnlineBookingModal from "../common/OnlineBookingModal";
import { useState } from "react";

type Props = {
  data: any;
};

const CardOnlineProfile = ({ data }: Props) => {
  const [modal, setModal] = useState<any>();
  const closeModal = () => setModal(false);
  return (
    <>
      <OnlineBookingModal modal={modal} data={data} closeModal={closeModal} />
      <div className="bg-white h-full px-3 py-4 flex flex-col items-center gap-4 rounded-xl w-1/2">
        <span className="text-color-primary text-base font-semibold">
          Online Profile
        </span>
        <Button type="primary" onClick={() => setModal(true)}>
          <div className="flex items-center gap-2">
            <MdOutlineRemoveRedEye className="text-white flex items-center" />
            <span>View</span>
          </div>
        </Button>
      </div>
    </>
  );
};

export default CardOnlineProfile;
